import { render, staticRenderFns } from "./_formsContact.vue?vue&type=template&id=b9c4db82&"
import script from "./_formsContact.vue?vue&type=script&lang=js&"
export * from "./_formsContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports